
import { motion } from 'framer-motion';

export default function PricingCTA() {
  const guarantees = [
    { icon: 'ri-shield-check-line', title: 'Prix fixe garanti', desc: 'Aucun supplément surprise, le prix annoncé est le prix final' },
    { icon: 'ri-time-line', title: 'Disponible 24h/24', desc: 'Réservation et prise en charge à toute heure, 7j/7' },
    { icon: 'ri-refund-2-line', title: 'Annulation gratuite', desc: 'Annulation sans frais jusqu\'à 24h avant le départ' },
    { icon: 'ri-customer-service-2-line', title: 'Support dédié', desc: 'Un interlocuteur unique pour votre réservation' },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Garanties */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-20"
        >
          {guarantees.map((g, idx) => (
            <motion.div
              key={g.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="text-center p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:shadow-lg hover:border-voyage-gold/20 transition-all"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-voyage-gold to-amber-500 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className={`${g.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="font-playfair text-lg font-bold text-night-blue mb-2">{g.title}</h3>
              <p className="font-inter text-sm text-slate-600 leading-relaxed">{g.desc}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* CTA principal */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative rounded-3xl overflow-hidden"
        >
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/32a48de88bf5be6be3e887c50a96deb1.jpg"
              alt="Réservez votre transfert premium dans les Alpes"
              title="Réservation transfert chauffeur privé Alpes"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/40"></div>
          </div>

          <div className="relative z-10 p-10 md:p-16 max-w-2xl">
            <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-4">
              Prêt à réserver votre transfert ?
            </h2>
            <p className="font-inter text-lg text-white/85 mb-8 leading-relaxed">
              Contactez-nous dès maintenant pour réserver votre chauffeur privé. Réponse garantie en moins de 30 minutes.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="https://wa.me/33605606006"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-8 py-4 bg-[#25D366] text-white rounded-full font-inter font-bold text-lg hover:bg-[#20BA5A] hover:scale-105 transition-all shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
              <a
                href="/reservation"
                className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-voyage-gold to-amber-500 text-night-blue rounded-full font-inter font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-check-line text-xl"></i>
                Réserver en ligne
              </a>
              <a
                href="tel:+33605606006"
                className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/30 text-white rounded-full font-inter font-bold text-lg hover:bg-white/10 hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Appeler
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
